<div class="card custom-box mb-1 border-0">
  <div class="card-body">
      <div class="row">
        <div class="col-1 text-center">
          <label class="col-form-label">1</label>
        </div>
        <div class="col-9 text-start">
          <label class="col-form-label">หนังสือแจ้งการตรวจสอบการลงทะเบียนพลการ</label>
        </div>
        <div class="col-2 text-start">
          <button type="submit" class="btn btn-outline-primary me-3">
            จัดทำ
          </button>
        </div>
      </div>
  </div>
</div>

<div class="card custom-box mb-1 border-0">
  <div class="card-body">
    <div class="row">
      <div class="col-1 text-center">
        <label class="col-form-label">2</label>
      </div>
      <div class="col-9 text-start">
        <label class="col-form-label">หนังสือตอบกลับจากหน่วยบริการ</label>
      </div>
      <div class="col-2 text-start">
        <button type="submit" class="btn btn-outline-primary me-3">
          จัดทำ
        </button>
      </div>
    </div>
  </div>
</div>
